var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex"},_vm._l((_vm.suits),function(suit,i){return _c('div',{key:i,staticClass:"single-card",class:[
            {
                'mr-4': i + 1 != _vm.suits.length,
            },
            _vm.getCardColor(suit),
        ],attrs:{"disabled":!_vm.isDrawn(suit),"data-value":_vm.getCardValue('king'),"data-suit":_vm.getCardSuit(suit)}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }